import React from 'react'
import MainBlock from './MainBlock/MainBlock'
import Numbers from './Numbers/Numbers'
import History from './History/History'
import Header from '../../Modules/Header/Header'
const MissionPage = () => {
  return (
    <div>
      <Header />
      <MainBlock />
      <Numbers />
      <History />
    </div>
  )
}

export default MissionPage
